/* eslint-disable */
import { useState } from 'react';
import { useRecoilState } from 'recoil';
import { popupState } from '../atoms';
import { text1, text2 } from '../text';
import Popup from './popup';
export default function Footer() {
  let [popup, setPopup] = useRecoilState(popupState);
  let [popTitle, setPopTitle] = useState('');
  let [popTxt, setPopTxt] = useState('');
  return (
    <>
      <div className="footerWrap">
        <div className="footerInner">
          <img src="/img/logo_black.png" alt="logo" />
          <div className="footerBox">
            <div>
              서울특별시 마포구 양화로 92 유남빌딩 4, 6층 (04043)
              <br />
              Tel. +82.70.8633.2377
              <br />
              Fax. +82.2.712.9007
              <br />
              E-mail. dxclaim@dxclaim.com
              <br />
              사업자등록번호: 499-86-02653
            </div>
            <div className="footerBtnBox">
              <button
                className="footerBtn"
                onClick={() => {
                  setPopup(true);
                  setPopTitle('이용약관');
                  setPopTxt(text1);
                }}
              >
                이용약관
              </button>
              <button
                className="footerBtn"
                onClick={() => {
                  setPopup(true);
                  setPopTitle('개인정보처리방침');
                  setPopTxt(text2);
                }}
              >
                개인정보처리방침
              </button>
            </div>
          </div>
        </div>
      </div>
      {popup ? <Popup txt={popTxt} title={popTitle} /> : ''}
    </>
  );
}
